// extracted by mini-css-extract-plugin
export default {"wrap":"OrdersPage_wrap__7JMdv","menuBlock":"OrdersPage_menuBlock__RJI6b","outletBlock":"OrdersPage_outletBlock__yPjZk"};